<template>
  <WujieVue
    id="child-app-iframe"
    width="100%"
    :alive="true"
    height="100%"
    name="eav3"
    :url="url"
    :props="{
      parentStore: $store,
      parentMaxRouter: $router,
      request: request,
    }"
    :plugins="plugins"
    :activated="onChildMounted"
  ></WujieVue>
</template>

<script>
import { microBaseUrl } from '@/modules/projectA/api/config';
import { getSubPath } from '@/modules/projectA/utils/utils';
import request from '@/modules/projectA/api/request';
import { EventTargetPlugin, DocElementRectPlugin } from 'wujie-polyfill';
const queryString = window.location.href.split("?")[1]
  ? `?${window.location.href.split("?")[1]}`
  : "";
export default {
  // created(){
  //   const route = this.$route;
  //   this.emitRouterChange(route);
  // },
  // mounted(){
  //   this.$nextTick(()=>{
  //      const route = this.$route;
  //   this.emitRouterChange(route);
  //   })

  // },
  beforeRouteUpdate(to, from, next) {
    // console.log(123)
    this.emitRouterChange(to);
    next();
  },
  data() {
    return {
      url: `${microBaseUrl}${getSubPath(window.location.href, 'eav3')}${queryString}`,
      request,
      plugins: [
        {
          patchElementHook(element, iframeWindow) {
            if (element.nodeName === 'STYLE') {
              element.insertAdjacentElement = function (_position, ele) {
                iframeWindow.document.head.appendChild(ele);
              };
            }
          },
        },
        {
          // 在子应用所有的css之前
          cssBeforeLoaders: [
            // 强制使子应用body定位是relative
            { content: 'body{position: relative !important}' },
          ],
        },
        {
          jsLoader: (code) => {
            // 替换popper.js内计算偏左侧偏移量
            const codes = code.replace(
              'left: elementRect.left - parentRect.left',
              'left: fixed ? elementRect.left : elementRect.left - parentRect.left'
            );
            // 替换popper.js内右侧偏移量
            return codes.replace(
              'popper.right > data.boundaries.right',
              'false'
            );
          },
        },
        EventTargetPlugin,
        DocElementRectPlugin,
      ],
    };
  },
  methods: {
    onChildMounted() {
      this.$nextTick(() => {
        const route = this.$route;
        this.emitRouterChange(route);
      });
    },
    emitRouterChange(to) {
      this.$bus.$emit(`eav3:router-change`, {
        path: `${getSubPath(to.path, 'eav3') || to.path}`,
        query: to.query,
        params: to.params,
        replace: false,
      });
    },
  },
};
</script>
